import api from './api';

const syncPaymentService = {
    resolve: (hotelId, accountId) =>
        api.get(`/sync-payment/resolve?hotelId=${hotelId}&accountId=${accountId}`),
    // hotelId picks whose card it is (the hotel's Billing-tab payer); pass the same one to the subscription.
    createSetupIntent: (accountId, accountName, hotelId) =>
        api.post('/sync-payment/setup-intent', { accountId, accountName, hotelId: hotelId ?? null }),
    subscribe: (data) =>
        api.post('/sync-payment/subscribe', data),
    createInvoice: (data) =>
        api.post('/sync-payment/invoice', data),
    resendInvoice: (data) =>
        api.post('/sync-payment/invoice/resend', data),
    getInvoiceDetails: (syncProjectId) =>
        api.get(`/sync-payment/invoice/details?syncProjectId=${encodeURIComponent(syncProjectId)}`),
    markInvoicePaid: (syncProjectId) =>
        api.post('/sync-payment/invoice/mark-paid', { syncProjectId }),
};

export default syncPaymentService;
